<template>
  <div id="app">
    <TopNav v-if="isDashboard!=true"/>
    <router-view/>
    <Footer v-if="isDashboard!=true"/>
  </div>
</template>

<script>
import TopNav from "@/components/TopNav.vue";
import Footer from "@/components/Footer.vue";
import {mapGetters} from 'vuex'
import nativeToast from 'native-toast'
import { RepositoryFactory } from './Repository/RepositoryFactory'
const PostsRepository = RepositoryFactory.get('posts_repository')
const OrderRepository = RepositoryFactory.get('order_repository')
const UserRepository = RepositoryFactory.get('user_repository')

export default {
  name: 'app',
  components: {
    TopNav,
    Footer
  },
  data(){
    return{
      isDashboard:false,
    }
  },
  computed:{
    ...mapGetters(['user_notifications','loggedUser','notifications','chatUser','FB']),
  },
  created() {

      this.fetchAllPosts()
      this.$store.dispatch("findAllUsers")

      if(localStorage.getItem("loggedUser")!=null) {
          this.$store.commit("setLoggedUser",JSON.parse(localStorage.getItem("loggedUser")))
          this.fetchUserNotifications(JSON.parse(localStorage.getItem("loggedUser")))
          if(localStorage.getItem("FB")!=null) {
            this.$store.commit("setFB",JSON.parse(localStorage.getItem("FB")))
          }
        }
        if(localStorage.getItem("user_resources")!=null){
          if(JSON.parse(localStorage.getItem('loggedUser').id!=21)){
            this.$store.commit("setUserResources",JSON.parse(localStorage.getItem("user_resources")))

          }
        }
        if(JSON.parse(localStorage.getItem("loggedUser")).id==21){
           this.fetchAdminAllSadqahOrders()
        }
        
   },
  methods:{
    async fetchAdminAllSadqahOrders() {
         var {data}= await OrderRepository.get_admin_sadqa_orders()
         this.$store.commit("setAdminResources",data[0])
      },
     async fetchAllPosts() {
         var {data}= await PostsRepository.all_posts()
         this.$store.commit("setPosts",data)
      },
      async fetchUserNotifications(user) {
        // user.id
         var {data}= await UserRepository.get_user_notifications({user_id:user.id})
         this.$store.commit("setUserNotifications",data[0])
      },
      checkboth(as){
        if(this.user_notifications.length>0 && this.chatUser!='') {

            let temp_viewed=this.chatUser.notifications!=null ? this.chatUser.notifications.viewed : 0 
              this.$store.dispatch("updateNotifications",{id:this.loggedUser.id,viewed:temp_viewed,unviewed:this.user_notifications.length - temp_viewed })  



        }

      }
  },
  watch:{
    
    '$route.name': {
        handler: function(route)  {
           if(route=='Dashboard') {
             this.isDashboard=true
             localStorage.setItem("route",'Dashboard')
           }
           else{
             this.isDashboard=false
             localStorage.removeItem("route")
             localStorage.setItem("route",route)

           }
        },
        deep: true,
        immediate: true
    },
    user_notifications(){
      if(this.user_notifications.length>0){
        this.checkboth("notif")
      }
    },
    chatUser(val){
       if(this.chatUser!=''){
            this.checkboth("chat")
            if(this.chatUser.chat_groups!=null){
              Object.keys(this.chatUser.chat_groups).forEach(item=>{
                this.$store.dispatch("fetchMessages",this.chatUser.chat_groups[item].id)
                
            })
            }
              
      }
       
    },
    loggedUser() {
      if(this.loggedUser!=null) {
        this.$store.dispatch("updateOnlineStatus",{id:this.loggedUser.id,status:true})

        this.$router.push({path:'/dashboard'})
        this.$store.dispatch("findChatUser",this.loggedUser.id)
         if(this.loggedUser.id==21){
           this.fetchAdminAllSadqahOrders()
          }
      }
      else{
        this.$router.push({path:'/'})
        location.reload();

      }
    },
    notifications(){
      if(this.notifications.message!=null) {
        nativeToast({
          message: this.notifications.message,
          position: 'north-east',
          timeout: 5000,
          type: this.notifications.type
          })
      }
    }
  }
}
</script>

<style>
audio:not(.md-image){
  height:8vh !important;
}
html.md-theme-default{
  background:white !important
}
#app {
  overflow: hidden !important;
  font-family: 'Montserrat','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
.bolds{
  font-weight:bold !important;
}

.left-aligned{
    text-align: left!important;
}
.right-aligned{
    text-align: right!important;
}
.carousel-inner {
  /* height: 85vh; */
}

.VueCarousel-dot{
  background-color: #28a745 !important;
}

.navbar-light .navbar-nav .nav-link:hover{
    color: white !important;
    /* border:1px solid #dcdcdc; */
    background-color: #28a745 !important;
    border-radius: 8px !important;
}
/* .navbar-dark .navbar-nav .nav-link {
    color: white !important;
}
.navbar-dark .navbar-nav .nav-link:hover {
    color: black !important;
} */
/* .dropdown{
      border:1px solid #dcdcdc;
      border-radius: 8px !important;
}
.dropdown:hover{
      border:1px solid #dcdcdc;
      background-color: #28a745;
      color:black !important;
      border-radius: 8px !important;
}

.dropdown-item{
  color:white !important
}
.dropdown-menu{
  background-color: #9E9E9E !important
} */

</style>
